<template lang='pug'>
.v-search.search(v-if="search")
	template(v-if="isTablet")
		v-panel(:close-text="search.closeText" :open-state="open" @close="close" :body-class="'search__panel-body'" @transitionend="focusInput")
			template(#content)
				v-loader(:loading="loading")
				.search__field(v-if="search.field" @close="close")
					v-field-search(:field="search.field" ref="field" @update:model-value="handleInput")
				.search__items(v-if="search?.items?.length" ref="list")
					a.navigation-links__item.search__item(v-for="item in search.items" :href="item.link")
						.search__item-content
							.search__item-title(v-if="item.text") {{item.text}}
							.search__item-breadcrumbs(v-if="item.items")
								span.search__item-breadcrumb(v-for="(breadcrumb, i) in item.items") {{breadcrumb}}
						v-svg-icon.navigation-links__item-icon(icon="arrow-right")
				.search__message(v-if="(!search.items || !search.items.length) && search.notFound")
					.search__message-title(v-if="search.notFound.title") {{search.notFound.title}}
	.template(v-else="")
		teleport(to="body")
			transition(name="overlay")
				.search__overlay(v-if="open" @click="close")
			.search__content(v-if="open")
				.container
					.search__field(v-if="search.field")
						v-field-search(:field="search.field" ref="field" @update:model-value="handleInput" @close="close")
					transition(name="overlay")
						.search__result.scrollbar(v-if="open && (search?.items?.length || search.notFound)")
							v-loader(:loading="loading")
							.search__items(v-if="search?.items?.length" ref="list")
								a.navigation-links__item.search__item(v-for="item in search.items" :href="item.link")
									.search__item-content
										.search__item-title(v-if="item.text") {{item.text}}
										.search__item-breadcrumbs(v-if="item.items")
											span.search__item-breadcrumb(v-for="(breadcrumb, i) in item.items") {{breadcrumb}}
									v-svg-icon.navigation-links__item-icon(icon="arrow-right")
							.search__message(v-if="(!search.items || !search.items.length) && search.notFound")
								.search__message-title(v-if="search.notFound.title") {{search.notFound.title}}

</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
import controller from '../scripts/controller/controller.js';
import scrollLock from "scroll-lock";
import {nextTick} from "vue";

export default {
	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			open: false,
			loading: false,
			localQuery: null,
			searchTimeout: null,
			search: {
				remote: null,
				query: null,
				link: null,
				suggestions: []
			},
			onFocus: false
		};
	},

	watch: {
		localQuery() {
			this.searchInput();
		},

		open(state) {
			if (state) {
				scrollLock.disablePageScroll(this.$refs.list);
				this.focusInput()
			} else {
				setTimeout(() => {
					scrollLock.enablePageScroll(this.$refs.list);
				}, 300);
			}
		}
	},

	mounted() {
		controller.events.on('openSearch', () => this.open = true);
		window.addEventListener('click', this.handleOpenByButton);
	},

	unmounted() {
		window.removeEventListener('click', this.handleOpenByButton);
	},

	methods: {
		relocate() {
			if (this.search.remote && this.localQuery) {
				let searchUrl = new URL(window.location.protocol + window.location.host + this.search.remote);
				searchUrl.searchParams.append('query', this.localQuery);
				window.location = searchUrl;
			}
		},

		close() {
			this.localQuery = null;
			this.open = false;
			this.search.items = [];
			if(this.search.notFound) {
				delete this.search.notFound;
			}
			this.search.suggestions = null;
		},

		handleInput(query) {
			this.localQuery = query;
		},

		searchInput() {
			if(this.localQuery && this.localQuery.length < 3) return;
			clearTimeout(this.searchTimeout);
			if (this.localQuery) {
				this.searchTimeout = setTimeout(this.requestDataLoad, 500);
			} else {
			}
		},

		requestDataLoad() {
			this.dataLoad({
				url: this.search.remote,
				delay: true,
				data: {
					query: this.localQuery,
					bxajaxid: this.bxajaxid
				}
			});
		},

		dataSet(data) {
			this.search = data;
		},

		async focusInput() {
			await nextTick();
			this.$refs.field?.$el.querySelector('input')?.focus();
		},

		handleOpenByButton(e) {
			if (e.target.closest('.js-open-search')) {
				this.open = true;
			}
		}
	}
};
</script>
